/* eslint-disable react/prop-types */
import React from 'react'
import { Typography, Space } from 'antd'
import { PictureOutlined } from '@ant-design/icons'

const { Text } = Typography

const ImgPlaceholder = ({ height = 260, caption }) => (
	<div
		style={{
			width: '100%',
			height,
			borderRadius: 16,
			background: '#f0f2f5',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			margin: '16px 0'
		}}
	>
		<Space direction="vertical" align="center">
			<PictureOutlined style={{ fontSize: 36, opacity: 0.5 }} />
			{caption ? <Text type="secondary">{caption}</Text> : null}
		</Space>
	</div>
)

export default ImgPlaceholder
